// components/Nudge.tsx
import { useEffect } from "react";
import { m } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useCommissionStore } from "../stores/commissionStore";
import { useIntakeCopy } from "../i18n/useIntakeCopy";
import { DUR, EASE_ENTER } from "../motion/tokens";
import type { NudgeId } from "../lib/nudges";

export function Nudge({ id }: { id: NudgeId }) {
  const { c } = useIntakeCopy();
  const dismiss = useCommissionStore((s) => s.dismissNudge);
  useEffect(() => { const t = setTimeout(() => dismiss(id), 6000); return () => clearTimeout(t); }, [id, dismiss]);
  return (
    <m.div key={id} role="note" layout
      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0, transition: { duration: DUR.ui, ease: EASE_ENTER } }} exit={{ opacity: 0, y: 6 }}
      className="relative flex items-center gap-3 rounded-xl border border-[var(--color-accent)]/40 bg-[var(--color-accent)]/10 px-4 py-2.5 text-sm text-[var(--color-text)]">
      <span aria-hidden className="absolute -top-1.5 left-6 h-3 w-3 rotate-45 border-l border-t border-[var(--color-accent)]/40 bg-[var(--color-bg-card)]" />
      <Sparkles className="h-4 w-4 shrink-0 text-[var(--color-accent)]" aria-hidden />
      <span className="flex-1">{c.nudges[id]}</span>
      <button type="button" onClick={() => dismiss(id)} className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text)]">{c.nudges.dismiss}</button>
    </m.div>
  );
}
